export default __webpack_public_path__ + "static/media/logo-gray-track.856cbfd1.png";